import { BILLING_STATUS, JUDICIAL_STATUS } from '../../invoice/constants'

export const ABBREVIATED_PANORAMA_INVOICE_STATUS = {
  PAID: 'OK',
  WAITING_PAYMENT: 'AB',
  LATE: 'L0',
  BILLING_STARTED: 'L1',
  NEGATIVE_OR_NONEXISTENT: 'L2',
  WAITING_BALANCE: 'L3',
  AWAITING_PAYMENT: 'L4',
  ENERGY_REPORT: 'L5',
  START_NOTIFICATION: 'L6',
  BROKEN_AGREEMENT: 'L7',
  JUDICIALIZE: 'J0',
  SEND_FRIENDLY_NOTIFY: 'G0',
  REGISTERED_FRIENDLY_NOTIFY: 'G1',
  SEND_SERASA: 'S0',
  REGISTERED_SERASA: 'S1',
  SEND_PROTEST: 'P0',
  PROTEST: 'P1',
  CAUSES_TO_SEND: 'M0',
  REGISTERED_CAUSES: 'M1',
  LOSS_OR_HARM: 'R0',
  INFORMAL_AGREEMENT: 'D0',
  AGREEMENT: 'D1',
  WAITING_GEN_INVOICE: 'F0'
}

export const PANORAMA_INVOICE_STATUS = {
  TOTAL: '[TT] Total',
  ...BILLING_STATUS,
  ...JUDICIAL_STATUS,
  WAITING_GEN_INVOICE: '[F0] Sem Fatura',
}
